import * as gfunctions from '../../../js/generalFunctions';

CCL.FbtObj = {
  autoload: [
    ['initialFbtLoad', $('#fbtComponent').length > 0],
    ['refreshWindow', $('body').length > 0]
  ],

  originalFbtResponse: null,

  refreshWindow() {
    $('body').on('click', '.refresh-window', () => {
      window.location.reload();
    });
  },

  initialFbtLoad() {
    // check if anything is not checked on first load also
    this.disableProduct();

    $('body').on('click', '.product-name input[type="checkbox"]', (event) => {
      let totalPrice = 0;
      let totalStrikeoutPrice = 0;
      let havingStikeOut = false;
      $('#fbtComponent').find('.product-name input[type="checkbox"]:checked').each((index, element) => {
        const { productId, price, stikeoutprice } = element.dataset;
        totalPrice += Number(price);
        if (stikeoutprice) {
          totalStrikeoutPrice += Number(stikeoutprice) > 0 ? Number(stikeoutprice) : Number(price);
          if (Number(stikeoutprice) > 0) {
            havingStikeOut = true;
          }
        }
      });
      $('#fbtTotalPrice').html(`$${(totalPrice).toFixed(2)}`);
      $('#fbtTotalPrice').attr('aria-label', `current price is $${(totalPrice).toFixed(2)}.`);
      if (totalStrikeoutPrice > 0 && havingStikeOut && totalStrikeoutPrice !== totalPrice) {
        $('#fbtTotalStikeoutPrice').html(`$${(totalStrikeoutPrice).toFixed(2)}`);
        $('#fbtTotalStikeoutPrice').attr('aria-label', ` old price was $${(totalStrikeoutPrice).toFixed(2)}.`);
      } else {
        $('#fbtTotalStikeoutPrice').html('');
        $('#fbtTotalStikeoutPrice').removeAttr('aria-label');
      }

      this.disableProduct();
    });

    $('body').on('click', '.fbt-atc', (event) => {
      this.fbtAddToCart(event);
    });

    $('body').on('click', '.fbtSuccessModal', () => {
      this.openFbtSuccessModal();
    });
  },

  openFbtSuccessModal() {
    console.log('NEED TO OPEN FBT SUCCESS MODAL');
    $('#conflictModal .close').removeClass('fbtSuccessModal');
    CCL.addToCart.successModal(this.originalFbtResponse);

    // if you are on cart page then reload the page for FBT
    if ($('body').find('.c-cart').length) {
      $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
      $('body').find('#addToCartSuccessModal .keepShopingLink').attr('href', '/booked/home');
    }
  },

  disableProduct() {
    $('.fbt-img').removeClass('disable-img');
    // Loop through all Non checked to reduced iterations
    $('#fbtComponent').find('.product-name input[type="checkbox"]:not(:checked)').each((index, element) => {
      const productId = element.dataset.productid;
      $(`#productImg-${productId}`).addClass('disable-img');
    });

    // Check if something is checked and then enable button
    const checkedLength = $('.product-name input[type="checkbox"]:checked').length;
    $('.fbt-atc').attr('aria-label', `Add ${checkedLength} products to cart`);
    if (checkedLength) {
      $('.fbt-atc').removeAttr('disabled');
    } else {
      $('.fbt-atc').attr('disabled', 'disabled');
    }
  },

  showFbtCCerror() {
    $('.cc-fbt-error').remove();
    $('#fbtComponent .product-section').append(`<div class='cc-fbt-error'
              aria-live='assertive'
              role='alert'
              style='color:darkred'>
      Cruise Cash limit is $500 per stateroom.
      </div>`);
  },

  fbtAddToCart(event) {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const dataObj = {};
    const tempArr = [];

    $('#fbtComponent').find('.product-name input[type="checkbox"]:checked').each((index, element) => {
      const productId = element.dataset.productid;
      tempArr.push({
        variantId: productId
      });
    });

    dataObj.productCard = tempArr;

    let ajaxUrl = '/shop/cart/fbt/addToCart';
    let ajaxType = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '../json-data/fbt-add-to-cart.json';
      ajaxType = 'GET';
    }
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      gfunctions.hideLoader();
      gfunctions.ajaxForCruiseCashCartAmount();
      this.originalFbtResponse = response;
      // if one product is having conflict then we need to open its conflict modal
      if (response.cartResponse.length) {
        if (response.cartResponse && response.cartResponse.filter(x => x.errorMsg.toLowerCase().includes('cruise cash')).length) {
          if (!response.cartModification) {
            this.showFbtCCerror();
          } else {
            this.showFbtCCerror();
            CCL.addToCart.successModal(response);
            if (event.target.dataset.cartpage) {
              $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
            }
            if (response.orderSummary && response.orderSummary.allProductDetails) {
              const res = { totalItemsCount: response.orderSummary.allProductDetails.length };
              gfunctions.updateHeaderCartWidget(res);
            }
          }
        } else {
          const shoreExProdsArr = response.cartResponse.filter(x => x.productType.code === 'EX');
          if (response.cartModification && response.cartModification.cartModificationDetails.length) {
            const addedProducts = response.cartModification.cartModificationDetails.filter(x => x.quantityAdded > 0);
            $.each(addedProducts, (index, value) => {
              CCL.conflictModal.fbtAddedProducts.push(value.product.code);
            });
          }

          // if its shorex Products
          if (shoreExProdsArr.length) {
            CCL.conflictModal.displayedData = CCL.conflictModal.modifyConflictJSON(shoreExProdsArr[0]);
            CCL.conflictModal.openConflictModal(CCL.conflictModal.displayedData);
            setTimeout(() => {
              $('#conflictModal .close').addClass('fbtSuccessModal');
            }, 300);
          }
        }
      } else {
        CCL.addToCart.successModal(response);
        if (event.target.dataset.cartpage) {
          $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
        }
        if (response.orderSummary && response.orderSummary.allProductDetails) {
          const res = { totalItemsCount: response.orderSummary.allProductDetails.length };
          gfunctions.updateHeaderCartWidget(res);
        }
      }
      console.log('FBT Add to Cart success');
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('FBT addt to cart error');
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-fbt/c-fbt.js